import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IModifiersFeature } from './modifiers.feature.state';
import { ModifiersState } from './modifiers.state';

export const getModifiersState: MemoizedSelector<IModifiersFeature, ModifiersState> = createFeatureSelector<ModifiersState>(
  nameof<IModifiersFeature>('modifiersFeature')
);

export const getIsLoading = createSelector(getModifiersState, (state: ModifiersState) => state.isLoading);
export const getFailures = createSelector(getModifiersState, (state: ModifiersState) => state.failures);
export const getModifiers = createSelector(getModifiersState, (state: ModifiersState) => state.modifiers);
